module.exports = __webpack_public_path__ + "img/background-1.7fe156ff.png";